export default __webpack_public_path__ + "static/media/ltc.0c0f8d1f.mp4";